import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { CasesState } from "./types";
import {
  generateCaseSolutionPromptAction,
  getAiExamplesAction,
  getAiScoringAction,
  getAiTipAction,
} from "./actions";

export function getAiScoringReducerBuilder(
  builder: ActionReducerMapBuilder<CasesState>,
) {
  builder.addCase(getAiScoringAction.pending, (state) => {
    state.isCasesLoading = true;
  });
  builder.addCase(getAiScoringAction.fulfilled, (state, action) => {
    state.isCasesLoading = false;
    if (!state.caseValue || !action.payload) return;
    state.caseValue.ai_scoring = action.payload;
  });
  builder.addCase(getAiScoringAction.rejected, (state) => {
    state.isCasesLoading = false;
  });
}

export function getAiExamplesReducerBuilder(
  builder: ActionReducerMapBuilder<CasesState>,
) {
  builder.addCase(getAiExamplesAction.pending, (state) => {
    state.isExamplesLoading = true;
  });
  builder.addCase(getAiExamplesAction.fulfilled, (state, action) => {
    state.isExamplesLoading = false;
    if (!state.caseValue || !action.payload) return;
    const { selectedId, result } = action.payload;
    state.aiExamples[selectedId as string] = result;
  });
  builder.addCase(getAiExamplesAction.rejected, (state) => {
    state.isExamplesLoading = false;
  });
}

export function getAiTipReducerBuilder(
  builder: ActionReducerMapBuilder<CasesState>,
) {
  builder.addCase(getAiTipAction.pending, (state, action) => {
    const field = action.meta.arg;
    state.isTipLoading[field] = true;
  });
  builder.addCase(getAiTipAction.fulfilled, (state, action) => {
    const field = action.meta.arg;
    state.isTipLoading[field] = false;
    if (!action.payload) return;
    state.aiTip = action.payload;
  });
  builder.addCase(getAiTipAction.rejected, (state, action) => {
    const field = action.meta.arg;
    state.isTipLoading[field] = false;
  });
}

export function generateCaseSolutionPromptReducerBuilder(
  builder: ActionReducerMapBuilder<CasesState>,
) {
  builder.addCase(generateCaseSolutionPromptAction.pending, (state) => {
    state.isSolutionLoading = true;
  });
  builder.addCase(
    generateCaseSolutionPromptAction.fulfilled,
    (state, action) => {
      state.isSolutionLoading = false;
    },
  );
  builder.addCase(generateCaseSolutionPromptAction.rejected, (state) => {
    state.isSolutionLoading = false;
  });
}
